/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import { useCallback } from 'react';

import { useParams } from 'react-router-dom';

import { icons } from '../../../../../assets';
import { EOnboardingComponentsId } from '../../../../../modules/onboarding/types/onboardingTypes';
import { AccessComponentKeyEnum } from '../../../../../modules/role/constants/guard/guardConstants';
import { ExternalRoutePath, openExternalRoute } from '../../../../../routes/constants/externalRoutes';
import { IRouteParams } from '../../../../../routes/constants/routesConstants';
import { stringFormat } from '../../../../../utils/stringFormat';
import { TableFooterNameType } from '../../../../Table/types/tableTypes';
import { TTableButtonsGetTranslation, TUseTableFooterButtonsUrl } from '../useTableFooterButtons';

const useTableFooterButtonDcRules = (
    getTranslation: TTableButtonsGetTranslation,
    tableFooterName: TableFooterNameType,
) => {
    const { clientId } = useParams<IRouteParams>();

    return {
        className: 'table-footer__link link-costs-separate',
        dataName: 'costs-separate',
        icon: icons.saleIcon,
        id: AccessComponentKeyEnum.FooterButtonDcruleList,
        onboarding: EOnboardingComponentsId.accountsTableFooterButtonDcRules,
        ...getTranslation(AccessComponentKeyEnum.FooterButtonDcruleList),

        onClick: useCallback(() => {
            const urlConfig = mapTableFooterNameToUrl[tableFooterName];
            if (!urlConfig) return;

            openExternalRoute(stringFormat(urlConfig.external, clientId));
        }, [tableFooterName, clientId]),
    };
};

const mapTableFooterNameToUrl: Partial<TUseTableFooterButtonsUrl> = {
    [TableFooterNameType.account]: {
        url: '',
        external: ExternalRoutePath.accountDcRules,
    },
    [TableFooterNameType.accountId]: {
        url: '',
        external: ExternalRoutePath.accountDcRulesId,
    },
};

export default useTableFooterButtonDcRules;
